/* eslint-disable-next-line */
import Swiper from 'swiper/bundle'; // NOSONAR
import SwiperExt from '../swiper';

const { feWp } = window;
const { addFilter,addAction } = feWp.hooks;

addFilter( 'b3rg_slider_library', 'b3rg/slider', () => {
  return SwiperExt;
} );

addAction(
  'b3rg_slider_init',
  'b3rg/slider',
  ( settings, el, swiper ) => {
    const parentSection = el.closest( '.e-stn--smart-features-slider' );
    if ( parentSection ) {
      const isInfinite = settings.loop;
      if ( isInfinite ) {
        swiper.params.supports4k = true;
        swiper.params.longSwipesRatio = 0;
        swiper.params.threshold = 0;
        swiper.params.touchRatio = 0.1;
        swiper.params.autoplay = {
          delay: 0, // Set the delay to 0 for continuous autoplay
        };
        swiper.params.speed = 2500;
        swiper.update();
      }
    }
  },
  10,
  1
);
